// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"CartModel_backdrop__3EwAT","modal":"CartModel_modal__30Fpy","slide-down":"CartModel_slide-down__2-g8s"};